import { ChevronUpIcon, } from "@heroicons/react/24/outline"; // Heroicons v2
import createIcon from "./createIcon";

const KeyboardArrowUp = createIcon(ChevronUpIcon, "KeyboardArrowUp");

export default KeyboardArrowUp;
